// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

interface OwnProps {
    date?: Date | null;
}

type Props = OwnProps;

const xUseTimeSlots = ({ date }: Props) => {
    if (!date) {
        return { timeSlots: [] };
    }

    const currentDate = new Date();
    const startDate = new Date(date);
    const isToday = startDate.toDateString() === currentDate.toDateString();

    let startHour = 0;
    let startMinutes = 0;

    if (isToday) {
        startHour = currentDate.getHours();
        startMinutes = Math.ceil(currentDate.getMinutes() / 30) * 30;
        // Round up the start minutes to the next half-hour
    }

    const timeSlots = [];

    for (let hour = startHour; hour <= 23; hour++) {
        for (let minutes = startMinutes; minutes < 60; minutes += 30) {
            const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
            const period = hour < 12 ? "AM" : "PM";
            const formattedMinutes = minutes.toString().padStart(2, "0");
            const formattedTime = `${formattedHour}:${formattedMinutes} ${period}`;
            timeSlots.push(formattedTime);
        }
        startMinutes = 0; // Reset minutes after the first loop
    }

    return { timeSlots };
};

export const setDateTime = (date: Date, selectedTimeSlot: any) => {
    const tempDate = date;
    const [hours, minutes, period] = selectedTimeSlot.match(/\d+|AM|PM/g);
    const hours24 = period === "PM" && hours !== "12" ? parseInt(hours, 10) + 12 : parseInt(hours, 10);
    tempDate.setHours(hours24, parseInt(minutes, 10), 0, 0);

    return tempDate;
};

export const getDateTime = (date: Date) => {
    const options = { hour: "numeric", minute: "numeric", hour12: true } as any;
    const dateTimeFormat = new Intl.DateTimeFormat("en-US", options);
    return dateTimeFormat.format(date);
};

export default xUseTimeSlots;
